import React, { useContext } from "react";
import styled from "@emotion/styled";
import Container from "@src/components/Container";
import FAQTile from "@src/components/partials/schools/FAQTile";
import { Title, Space, Button, BodyText, theme } from "@src/components/nessie-web";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { mediaQueries } from "@src/styles/theme";

const {
  colors: { dt_taro10, dt_taro90 },
} = theme;

const FAQSectionContainer = styled.section`
  background-color: ${dt_taro10};
  padding: 54px 0;

  ${mediaQueries[0]} {
    padding: 108px 0 54px;
`;

const FAQWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueries[0]} {
    max-width: 575px;
    margin: auto;
  }
`;

const FAQTitle = styled.h2`
  font-weight: 800;
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.2px;
  margin: 0;
  color: ${dt_taro90};

  ${mediaQueries[0]} {
    font-size: 44px;
    line-height: 48px;
    letter-spacing: -0.4px;
  }
`;

const FAQHelpText = styled.p`
  color: ${dt_taro90};
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.25px;
  text-align: center;

  a {
    color: ${dt_taro90};
    text-decoration: underline;
  }
`;

type FAQSectionProps = {
  faq_title: string;
  faq_items: any;
  faq_item_caret_alt: string;
  translationPath: string;
  help_text: string;
};

const RedesignFAQSection: React.FC<FAQSectionProps> = ({
  faq_title,
  faq_items,
  faq_item_caret_alt,
  translationPath,
  help_text,
}) => {
  const t = useContext(TranslationContext);

  return (
    <>
      <FAQSectionContainer>
        <Container>
          <FAQWrapper>
            <FAQTitle>{t.translate(faq_title)}</FAQTitle>
            <Space size="m" />
            {faq_items.map((item, idx) => (
              <FAQTile
                key={`item_${idx + 1}`}
                faq_item_title={`${translationPath}redesign_faq_items.title_${idx + 1}`}
                faq_item_content={`${translationPath}redesign_faq_items.content_${idx + 1}`}
                faq_item_caret_alt={faq_item_caret_alt}
                faq_item_bg_white={true}
              />
            ))}
            <Space size="l" />
            {help_text && (
              <>
                <FAQHelpText>{t.translate(help_text)}</FAQHelpText>
              </>
            )}
          </FAQWrapper>
        </Container>
      </FAQSectionContainer>
    </>
  );
};

export default RedesignFAQSection;
